import React, { FC, useContext } from 'react';
import Grid from '@mui/material/Grid';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { UseFormReturn } from 'react-hook-form';
import { TextInputController } from '../InputControllers/TextInputController';
import { useScrollToError } from '../../hooks/useScrollToError';
import { useTranslation } from 'react-i18next';
import { ProductPackagesFetcher } from '../../fetchers/ProductPackagesFetcher';
import { useAutoFetch } from '../../contexts/Fetcher';
import { TransferList } from '../InputControllers/TransferList';

export interface IProductFormPayload {
  name: string;
  installerPath: string;
  docsPath: string;
  packages: string[];
}

interface IProps {
  form: UseFormReturn;
  onSubmit: (data: IProductFormPayload) => void;
  isEdit?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    packagesTransferList: {
      height: 300,
    },
  })
);

export const ProductForm: FC<IProps> = ({ form, onSubmit, isEdit = false }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { data: packagesData } = useContext(ProductPackagesFetcher.Context);
  useAutoFetch(ProductPackagesFetcher);

  const { formRef } = useScrollToError(form);

  if (!packagesData) return null;

  return (
    <Grid container spacing={1} component={'form'} onSubmit={form.handleSubmit(onSubmit)} ref={formRef}>
      <Grid item xs={12}>
        <TextInputController
          control={form.control}
          errors={form.formState.errors}
          rules={{ required: true }}
          label={t('adminProducts.products.form.name')}
          name="name"
        />
      </Grid>

      <Grid item xs={12}>
        <TransferList
          form={form}
          name="packages"
          label={t('adminProducts.products.form.packages')}
          data={packagesData.packages}
          compare={(item, value: string) => item.id === value}
          getItemKey={(item) => item.id}
          getItemLabel={(item) => item.name}
          valueGenerator={(item) => item.id}
          availableListLabel={t('adminProducts.products.form.availablePackages')}
          chosenListLabel={t('adminProducts.products.form.chosenPackages')}
          classNames={{
            itemsList: styles.packagesTransferList,
          }}
        />
      </Grid>

      {!isEdit ? (
        <Grid item xs={12} md={6}>
          <TextInputController
            control={form.control}
            errors={form.formState.errors}
            rules={{ required: true }}
            label={t('adminProducts.products.form.installerPath')}
            name="installerPath"
            InputProps={{
              placeholder: 'pixotope/',
            }}
          />
        </Grid>
      ) : null}

      {!isEdit ? (
        <Grid item xs={12} md={6}>
          <TextInputController
            control={form.control}
            errors={form.formState.errors}
            rules={{ required: true }}
            label={t('adminProducts.products.form.docsPath')}
            name="docsPath"
            InputProps={{
              placeholder: 'docs/pixotope/',
            }}
          />
        </Grid>
      ) : null}
    </Grid>
  );
};
